import { Account } from 'api/userApi';
import { createContext, useContext } from 'react';

export interface Accounts {
  accounts: Account[];
}

export interface Store {
  balances: any;
  setBalances: (balances: any) => void;
  supportedCurrencies: any;
  setSupportedCurrencies: (paymentMethods: any) => void;
  supportedBalanceCurrencies: any;
  setSupportedBalanceCurrencies: (currencies: any) => void;
  accountName: string;
  setAccountName: (accountName: string) => void;
  businessName: string;
  setBusinessName: (businessName: string) => void;
  v4Username: string;
  setV4Username: (v4Username: string) => void;
  user: Accounts | null;
  setUser: (user: any) => void;
  customer: Accounts | null;
  setCustomer: (customer: any) => void;
  mfaEnabled: boolean | null;
  setMfaEnabled: (enabled: boolean | null) => void;
  profileDetails: {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
  };
  setProfileDetails: (
    firstName: string | null,
    lastName: string | null,
    email: string | null
  ) => void;

  isMobileView: boolean | undefined;
  setIsMobileView: (isMobileView: boolean) => void;
}

const store: Store = {
  balances: [],
  setBalances: () => {},
  supportedCurrencies: null,
  setSupportedCurrencies: () => {},
  supportedBalanceCurrencies: [],
  setSupportedBalanceCurrencies: () => {},
  accountName: '',
  setAccountName: () => {},
  businessName: '',
  setBusinessName: () => {},
  v4Username: '',
  setV4Username: () => {},
  user: null,
  setUser: () => {},
  customer: null,
  setCustomer: () => {},
  mfaEnabled: false,
  setMfaEnabled: () => {},
  profileDetails: {
    firstName: '',
    lastName: '',

    email: '',
  },
  setProfileDetails: () => {},
  isMobileView: false,
  setIsMobileView: () => {},
};

const DashboardContext = createContext(store);
DashboardContext.displayName = 'Dashboard Context';
export const useDashboardContext = () => useContext(DashboardContext);
export default DashboardContext;
